const SrmDebugContextParams = {
  control: {
    paramType: "string"
  },
  treatment: {
    paramType: "string"
  },
  primarySegmentName: {
    paramType: "string"
  },
  primarySegmentValue: {
    paramType: "string"
  },
  nochrome: {
    paramType: "boolean"
  },
  multipleScorecards: {
    paramType: "string"
  },
  workspaceId: {
    paramType: "string"
  }
};
export {
  SrmDebugContextParams
};
//# sourceMappingURL=SrmDebugContext.js.map
